export const buildFlowContextIds = ({ conversation, inbox, contact } = {}) => {
  const context = {};
  if (conversation?.id) {
    context.conversationId = String(conversation.id);
  }
  if (inbox?.inbox_identifier) {
    context.inboxIdentifier = inbox.inbox_identifier;
  }
  if (inbox?.id) {
    const sourceId = contact?.contact_inboxes?.find(
      (contactInbox) => contactInbox?.inbox?.id === inbox.id
    )?.source_id;
    if (sourceId) {
      context.guestIdentifier = sourceId;
    }
  }
  return context;
};

export const pickSuggestPromptContents = (incomingContents, latestMessages) => {
  const incoming = (incomingContents || []).filter(Boolean);
  if (incoming.length) return incoming;
  const fallback = (latestMessages || [])
    .filter((message) => !message?.private)
    .map((message) => message?.content?.trim())
    .filter(Boolean);
  return fallback.slice(-1);
};

export const pickFallbackKeystoneFlowId = (flows, inboxId) => {
  if (!flows?.length) return null;
  const newest = (list) =>
    list.reduce((a, b) =>
      new Date(b.updatedAt || 0) > new Date(a.updatedAt || 0) ? b : a
    );
  const inboxFlows = flows.filter((f) => f.inboxId === inboxId);
  return newest(inboxFlows.length ? inboxFlows : flows).flowId || null;
};
